(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block-custom-coupon-card"] && !Shopify.designMode) return;
  try {
    const couponButtons = document.querySelectorAll('.coupon-btn[data-coupon]');

  couponButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const coupon = button.getAttribute('data-coupon');
      if (!coupon) return;

      navigator.clipboard.writeText(coupon).then(() => {
        const originalText = button.textContent;
        const copiedText = button.getAttribute('data-copied-text') || originalText;
        button.textContent = copiedText;

        setTimeout(() => {
          button.textContent = originalText;
        }, 2000);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-gifts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const ul = document.querySelector('.custom-gift-contet ul');
  if (!ul) return;

  // 所有非 show-more 的 li（礼品项）
  const giftLis = Array.from(ul.querySelectorAll('li:not(.show-more)'));
  const showMoreLi = ul.querySelector('li.show-more');
  const total = giftLis.length;

  // 如果没有 show-more 按钮或礼品数量 <= 3，则隐藏按钮并返回
  if (!showMoreLi || total <= 3) {
    if (showMoreLi) showMoreLi.style.display = 'none';
    return;
  }

  // 初始：确保第 1~3 项可见，第 4 项及以后隐藏（以防服务器端未设置）
  giftLis.forEach((li, idx) => {
    if (idx >= 3) li.style.display = 'none';
    else li.style.display = ''; // 恢复为默认（由 CSS 控制）
  });

  let expanded = false;
  showMoreLi.style.cursor = 'pointer';
  showMoreLi.textContent = `Show (${total}) more...`;

  showMoreLi.addEventListener('click', function(e) {
    e.preventDefault();
    if (!expanded) {
      // 展开：移除 inline display（恢复由 CSS 控制）
      giftLis.forEach(li => li.style.display = '');
      showMoreLi.textContent = 'Show less...';
    } else {
      // 收起：隐藏第 4 项及以后
      giftLis.forEach((li, idx) => {
        if (idx >= 3) li.style.display = 'none';
      });
      showMoreLi.textContent = `Show (${total}) more...`;
    }
    expanded = !expanded;
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebike-dropdowns"] && !Shopify.designMode) return;
  try {
    (function () {
  var groups = document.querySelectorAll('.ebike-dropdowns');
  if (!groups.length) return;

  
  function formatPrice(price) {
    return (price / 100).toFixed(2);
  }

  groups.forEach(function (group) {

    var selectedValue = group.querySelector('.ebike-dropdowns__selected-value');
    var options = group.querySelectorAll('.js-ebike-option');
    var basePriceEl = group.querySelector('.js-current-base-price');
    var diffEls = group.querySelectorAll('.js-diff-price');

    if (!selectedValue || !options.length || !basePriceEl) return;

    // 格式化价格
    function formatPrice(price) {
      return (price / 100).toFixed(2);
    }

    // 更新所有差价
    function updateDiffs(basePrice) {

      diffEls.forEach(function (el) {

        // 🔥 从 label 里拿“对应产品链接”
        var option = el.closest('.option').querySelector('.js-ebike-option');

        if (!option) return;

        // 👉 用 option.dataset.productUrl 去请求价格（进阶）
        // 👉 或者：直接用 DOM 主价格 + 逻辑

        var productPrice = parseInt(option.dataset.price || 0, 10);

        var diff = productPrice - basePrice;

        if (diff >= 0) {
          el.innerHTML = '+$' + formatPrice(diff);
        } else {
          el.innerHTML = '-$' + formatPrice(Math.abs(diff));
        }

      });

    }

    // 设置 base price
    function setBasePrice(price) {
      basePriceEl.dataset.basePrice = price;
      updateDiffs(parseInt(price, 10));
    }

    // init：默认值
    setBasePrice(basePriceEl.dataset.basePrice);

    options.forEach(function (option) {

      // 初始化选中状态
      if (option.checked) {
        var label = group.querySelector('label[for="' + option.id + '"]');
        if (label) {
          var text = label.querySelector('span:first-child')?.textContent.trim();
          if (text) selectedValue.textContent = text;
        }
      }

      option.addEventListener('change', function () {

        var label = group.querySelector('label[for="' + option.id + '"]');

        if (label) {
          var text = label.querySelector('span:first-child')?.textContent.trim();
          if (text) selectedValue.textContent = text;
        }

        // ✅ 核心：更新 base price
        setBasePrice(option.dataset.price);

        // 跳转
        var url = option.dataset.productUrl;
        if (url) {
          window.location.href = url;
        }

      });

    });

  });

// ===============================
// ✅ 监听 variant 变化（核心）
// ===============================
let lastVariantId = null;

function getVariantIdFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return params.get('variant');
}

function getMainPriceFromDOM() {
  const priceEl = document.querySelector('.price__regular');
  if (!priceEl) return 0;

  const text = priceEl.textContent.replace(/[^0-9.]/g, '');
  return Math.round(parseFloat(text) * 100);
}

function syncFromVariant() {
  const currentVariantId = getVariantIdFromUrl();

  if (!currentVariantId || currentVariantId === lastVariantId) return;

  lastVariantId = currentVariantId;

  const basePrice = getMainPriceFromDOM();

  if (!basePrice) return;

  // 🔥 更新当前选中价格
  groups.forEach(group => {
    const basePriceEl = group.querySelector('.js-current-base-price');
    const diffEls = group.querySelectorAll('.js-diff-price');

    basePriceEl.dataset.basePrice = basePrice;

    diffEls.forEach(el => {

      const option = el.closest('.option').querySelector('.js-ebike-option');

      const optionCheck = el.closest('.option')?.querySelector('input[type="radio"]');

      if (!option) return;

      const productPrice = parseInt(option.dataset.price || 0, 10);

      let diff = productPrice - basePrice;

      if(optionCheck.checked) {
          diff = 0
      }

      if (diff >= 0) {
        el.innerHTML = '+$' + formatPrice(diff);
      } else {

        el.innerHTML = '-$' + formatPrice(Math.abs(diff));
      }

    });

  });
}

// 1️⃣ popstate（浏览器前进后退）
window.addEventListener('popstate', syncFromVariant);

// 2️⃣ 定时兜底（最稳）
setInterval(syncFromVariant, 300);


})();
  } catch(e) { console.error(e); }
})();

})();
